import { Grid, InputLabel } from '@material-ui/core';
import {
  Backdrop,
  EditIconTwoTone,
  NotificationText,
  PlusIconTwoTone,
  Select,
  SingleFieldContactInput,
  TextInput,
  TrashErrorIconTwoTone,
  useNotificationModal,
} from '@room-match/shared-ui-components';

import React, { useEffect, useMemo, useState } from 'react';
import { useEmailValidation } from 'shared/hooks/useEmailValidation';
import { IAccountUpdatePayload, IEmailAddresses, IPhoneNumber } from 'shared/interfaces/IAccount';
import { accountService } from 'shared/services/accountService';
import {
  AddNewLocationButton,
  Column,
  CustomIconButton,
  FlexContainer,
  Heading,
  LocationActions,
  LocationContainer,
  MainCont,
  OneColumnGrid,
  SaveButton,
  TwoColumnGrid,
  useStyles,
} from './ContactInformation.styles';

import { useQueryClient } from 'react-query';
import { mappedCountry } from 'shared/utils/countryStateMapper';
import { getErrorMessage } from 'shared/utils/room-shared';
import { useContactInformationForm } from './ContactInformationForm';

import { LocationModal } from 'components';
import emergencyContactType from 'data/EmergencyContactType.json';
import { getIn } from 'formik';
import { IAddress } from 'shared/interfaces/IAddress';
import { countryStateApiService } from 'shared/services/countryStateApiService';
import { locationService } from 'shared/services/locationService';
import { capitalizeFirstLetter } from 'shared/utils/common';
import { ls } from 'shared/utils/ls';

const { getCountries, getAllStates } = countryStateApiService();
const { getAccount, updateAccount } = accountService();
const { deleteLocation } = locationService();
const ContactInformation = () => {
  const classes = useStyles();
  const { getLS, setLS } = ls();
  const guardianInfo = JSON.parse(getLS('guardian_account') ? getLS('guardian_account') : '{}');
  const { data: accountDetails, isLoading } = getAccount();
  const { mutateAsync, isLoading: updateAccountIsLoading } = updateAccount();
  const { mutateAsync: deleteLocationMutateAsync, isLoading: deleteLocationIsLoading } = deleteLocation();
  const [selectedLocation, setSelectedLocation] = useState<IAddress | null>(null);
  const [openLocationModal, handleOpenLocationModal] = useState<boolean>(false);
  const [showSuccess, handleShowSuccess] = useState<boolean>(false);
  const [renderContact, setrenderContact] = useState(false);
  const { data: countriesData } = getCountries();
  const [getAccountIsLoading, setgetAccountIsLoading] = useState(true);

  const {
    handleOpen: notificationOpen,
    isOpen: isNotificationOpen,
    NotificationModal: NotifModal,
    handleSetMessage: notificationMessage,
  } = useNotificationModal({
    type: 'error',
  });

  const queryClient = useQueryClient();

  const getAccountDetails = useMemo(() => {
    return accountDetails ? accountDetails.data : undefined;
  }, [accountDetails]);

  const { isEmailValidationLoading, isValidEmail, handleEmailChange, emailValue } = useEmailValidation();
  const handleSubmit = async (values: IAccountUpdatePayload) => {
    console.log('values', values);

    // Check if values.other_phone_numbers exists and is an array
    if (values.other_phone_numbers && Array.isArray(values.other_phone_numbers)) {
      const invalidPhoneNumber = values.other_phone_numbers.some((phoneNumber) => {
        return phoneNumber.number && phoneNumber.number.startsWith('0') && phoneNumber.country_code === 'AU';
      });

      if (invalidPhoneNumber) {
        // Display an error message or handle the invalid input as needed
        console.error('Invalid phone number: Cannot start with "0" for Australia country code.');
      } else {
        const newValue = { ...values };
        delete newValue.stage_first_name;
        delete newValue.stage_middle_name;
        delete newValue.stage_last_name;

        if (newValue.other_phone_numbers) {
          newValue.contact_no = newValue.other_phone_numbers.find((phone) => phone.type === 'primary')?.number || '';
        }
        mutateAsync(newValue, {
          onSuccess: (res) => {
            if (res.data.attributes.user_types.includes('guardian')) {
              setLS('guardian_account', JSON.stringify(res.data));
            }
            queryClient.invalidateQueries(['accounts'], {
              refetchInactive: true,
            });
            handleShowSuccess(true);
          },
          onError: (error) => {
            const { response } = error as { response: any };
            const { data } = response;
            if (data.errors) {
              const errorList = Object.keys(data.errors).map((k) => {
                return {
                  type: capitalizeFirstLetter(k),
                  val: data.errors[k],
                };
              });
              notificationOpen();
              const errmessage = errorList
                .map((err: any) => {
                  return err.val
                    .map(
                      (val: string) => `
                        ${err.type} ${val}`,
                    )
                    .join(', ');
                })
                .join(', ');
              notificationMessage('Save Error', errmessage, 'OK');
            }
          },
        });
      }
    } else {
      // Handle the case where other_phone_numbers is null or not an array
      console.error('other_phone_numbers is null or not an array');
    }
  };

  const { form } = useContactInformationForm({
    onSubmit: handleSubmit,
    data: getAccountDetails,
    isValidEmail: isValidEmail,
  });

  const getCountry = (country_code: String) => {
    return mappedCountry(countriesData || []).find((v) => v.value === country_code)?.key || '';
  };

  const handleLocationDelete = async (locationId: string) => {
    deleteLocationMutateAsync(
      { locationId: locationId },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['accounts'], {
            refetchInactive: true,
          });
        },
      },
    );
  };

  // useEffect(() => {
  //   console.log(
  //     'validatin',
  //     form.values,
  //     !form.values.other_email_addresses,
  //     !form.values.other_phone_numbers,
  //     getAccountDetails?.attributes.adult_minor.toLowerCase() !== 'minor',
  //   );

  //   if (
  //     (!form.values.other_email_addresses || !form.values.other_phone_numbers) &&
  //     getAccountDetails?.attributes.adult_minor.toLowerCase() !== 'minor'
  //   ) {
  //     console.log('getAccountDetails', getAccountDetails?.attributes.email);

  //     form.setFieldValue('other_email_addresses', INITIAL_EMAIL_ADDRESSES);
  //     form.setFieldValue('other_email_addresses[0].email', getAccountDetails?.attributes.email);

  //     form.setFieldValue('other_phone_numbers', INITIAL_PHONE_NUMBERS);
  //     form.setFieldValue('other_phone_numbers[0].number', getAccountDetails?.attributes.contact_no);
  //     form.setFieldValue('other_phone_numbers[0].country_code', getAccountDetails?.attributes.country_code);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [form.values.other_email_addresses, form.values.other_phone_numbers, getAccountDetails]);

  useEffect(() => {
    if (!form.values.emergency_contact) {
      form.setFieldValue('emergency_contact', {
        name: '',
        country_code: form.values.country_code?.toLowerCase() || 'us',
        phone_number: '',
        email: '',
        relationship: '',
      });
    }
  }, [form.values.emergency_contact]);

  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => {
        setgetAccountIsLoading(false);
      }, 1000);
    }
  }, [isLoading]);

  console.log({ form });

  if (getAccountIsLoading || updateAccountIsLoading || deleteLocationIsLoading)
    return (
      <Backdrop
        isLoading={
          getAccountIsLoading
            ? getAccountIsLoading
            : updateAccountIsLoading
              ? updateAccountIsLoading
              : deleteLocationIsLoading
                ? deleteLocationIsLoading
                : false
        }
      />
    );
  return (
    <>
      <MainCont>
        <Grid item>
          <p style={{ fontSize: 25 }}>Contact Information</p>
          {isNotificationOpen && <NotifModal />}
          {Boolean(guardianInfo.attributes) && getAccountDetails?.attributes.adult_minor.toLowerCase() === 'minor' ? (
            <Grid item>
              <Heading>Guardian Name</Heading>
              <Column>
                <Grid item lg={3} md={3} xs={12}>
                  <TextInput
                    disabled
                    label={'First Name'}
                    placeholder="Enter first name…"
                    className={classes.textInputStyle}
                    name="first_name"
                    value={guardianInfo.attributes.first_name}
                    onChange={(e) => {
                      if (form.errors.first_name && !form.touched.first_name) {
                        form.setFieldTouched('first_name');
                        form.validateField('first_name');
                      }
                      form.handleChange(e);
                    }}
                    onBlur={form.handleBlur}
                    errorMessage={getErrorMessage(form.touched.first_name, form.errors.first_name)}
                  />
                </Grid>
                <Grid item lg={3} md={3} xs={12}>
                  <TextInput
                    disabled
                    label={'Middle Name'}
                    placeholder="Enter middle name…"
                    name="middle_name"
                    value={guardianInfo.attributes.middle_name}
                    onChange={(e) => {
                      if (form.errors.middle_name && !form.touched.middle_name) {
                        form.setFieldTouched('middle_name');
                        form.validateField('middle_name');
                      }
                      form.handleChange(e);
                    }}
                    onBlur={form.handleBlur}
                    errorMessage={getErrorMessage(form.touched.middle_name, form.errors.middle_name)}
                  />
                </Grid>
                <Grid item lg={3} md={3} xs={12}>
                  <TextInput
                    disabled
                    label={'Last Name'}
                    placeholder="Enter last name…"
                    name="last_name"
                    value={guardianInfo.attributes.last_name}
                    onChange={(e) => {
                      if (form.errors.last_name && !form.touched.last_name) {
                        form.setFieldTouched('last_name');
                        form.validateField('last_name');
                      }
                      form.handleChange(e);
                    }}
                    onBlur={form.handleBlur}
                    errorMessage={getErrorMessage(form.touched.last_name, form.errors.last_name)}
                  />
                </Grid>
              </Column>
            </Grid>
          ) : (
            <React.Fragment />
          )}
        </Grid>
        {/*<Grid item>
          <Heading>Phone Number/s</Heading>
          <Column>
            {form.values.other_phone_numbers &&
              Array.isArray(form.values.other_phone_numbers) &&
              form.values.other_phone_numbers.map((data: IPhoneNumber, index) => (
                <Grid item lg={3} md={6} xs={12}>
                  <InputLabel id="contactNumber" style={{ marginBottom: '-15px' }}>
                    {capitalizeFirstLetter(data.type)} {data.type === 'primary' ? '*' : '(Optional)'}
                  </InputLabel>
                  <SingleFieldContactInput
                    country={data.number ? data.country_code : getAccountDetails?.attributes.country_code}
                    inputValue={data.number}
                    onChange={(value, data) => {
                      form.setFieldValue(`other_phone_numbers[${index}].country_code`, data.countryCode);
                      form.setFieldValue(`other_phone_numbers[${index}].number`, value);
                    }}
                  />
                </Grid>
              ))}
          </Column>
        </Grid>*/}
        <Grid item>
          <Heading>Phone Number/s</Heading>
          <Column>
            {form.values.other_phone_numbers &&
              Array.isArray(form.values.other_phone_numbers) &&
              form.values.other_phone_numbers.map((phoneData: IPhoneNumber, index) => (
                <Grid item lg={3} md={6} xs={12}>
                  <InputLabel id="contactNumber" style={{ marginBottom: '-15px' }}>
                    {getAccountDetails?.attributes.email.includes('temp-talent-email') &&
                    getAccountDetails?.attributes.adult_minor.toLowerCase() !== 'adult'
                      ? ''
                      : capitalizeFirstLetter(phoneData.type)}{' '}
                    {phoneData.type === 'primary'
                      ? `${
                          getAccountDetails?.attributes.email.includes('temp-talent-email') &&
                          getAccountDetails?.attributes.adult_minor.toLowerCase() !== 'adult'
                            ? `Guardian's Phone Number *`
                            : '*'
                        }`
                      : `(Optional)`}
                  </InputLabel>
                  <SingleFieldContactInput
                    disabled={
                      phoneData.type === 'primary' &&
                      getAccountDetails?.attributes.email.includes('temp-talent-email') &&
                      getAccountDetails?.attributes.adult_minor.toLowerCase() !== 'adult'
                        ? true
                        : false
                    }
                    country={
                      phoneData.country_code.toLowerCase() || getAccountDetails?.attributes.country_code.toLowerCase()
                    }
                    inputValue={
                      phoneData.type === 'primary' &&
                      getAccountDetails?.attributes.email.includes('temp-talent-email') &&
                      getAccountDetails?.attributes.adult_minor.toLowerCase() !== 'adult'
                        ? guardianInfo.attributes?.contact_no
                        : phoneData.number
                    }
                    onChange={(value, data) => {
                      if (phoneData.type === 'primary' && form.values.other_phone_numbers) {
                        form.values.other_phone_numbers.forEach((phone, i) => {
                          if (phone.number === '' && phone.type === 'primary') {
                            form.setFieldValue(`other_phone_numbers[${i}].country_code`, data.countryCode);
                          }
                        });
                      }

                      form.setFieldValue(`other_phone_numbers[${index}].country_code`, data.countryCode);
                      form.setFieldValue(`other_phone_numbers[${index}].number`, value);
                    }}
                  />
                </Grid>
              ))}
          </Column>
        </Grid>
        <Grid item>
          <Heading>Email Address</Heading>
          <Column>
            {form.values.other_email_addresses &&
              Array.isArray(form.values.other_email_addresses) &&
              form.values.other_email_addresses.map((data: IEmailAddresses, index) => (
                <Grid item lg={3} md={6} xs={12}>
                  <TextInput
                    disabled={
                      data.type === 'primary' &&
                      getAccountDetails?.attributes.email.includes('temp-talent-email') &&
                      getAccountDetails?.attributes.adult_minor.toLowerCase() !== 'adult'
                    }
                    label={
                      data.type === 'primary'
                        ? `${
                            getAccountDetails?.attributes.email.includes('temp-talent-email') &&
                            getAccountDetails?.attributes.adult_minor.toLowerCase() !== 'adult'
                              ? `Guardian's`
                              : 'Your'
                          } Email Address for Castings`
                        : `${capitalizeFirstLetter(data.type)} (Optional)`
                    }
                    placeholder="Enter email address…"
                    name={`other_email_addresses[${index}].email`}
                    value={data.email}
                    onChange={(e) => {
                      const { value } = e.target as { value: string };
                      form.setFieldValue(`other_email_addresses[${index}].email`, value);
                      if (data.type === 'primary') form.setFieldValue(`email`, value);
                    }}
                    onBlur={(e) => {
                      // handleEmailChange(e.target.value);
                      return form.handleBlur(e);
                    }}
                    errorMessage={getErrorMessage(
                      getIn(form.touched, `other_email_addresses[${index}].email`),
                      getIn(form.errors, `other_email_addresses[${index}].email`),
                    )}
                    InputProps={{
                      classes: {
                        root: classes.textInputStyle,
                      },
                    }}
                    // InputProps={{
                    //   tabIndex: 1,
                    //   endAdornment: (
                    //     <>
                    //       {emailValue && (
                    //         <>
                    //           {isEmailValidationLoading ? (
                    //             <LoadingSpinnerIconTwoTone style={{ fontSize: 40 }} />
                    //           ) : (
                    //             <>
                    //               {isValidEmail ? (
                    //                 <CheckboxCheckIconTwoTone style={{ fontSize: 12 }} />
                    //               ) : (
                    //                 <CloseIcon style={{ fontSize: 12 }} htmlColor={COLORS.DANGER} />
                    //               )}
                    //             </>
                    //           )}
                    //         </>
                    //       )}
                    //     </>
                    //   ),
                    // }}
                  />
                </Grid>
              ))}
          </Column>
        </Grid>
        <Grid item>
          <Heading>Emergency Contact</Heading>
          {form.values.emergency_contact && (
            <Column>
              <Grid item lg={3} md={6} xs={12}>
                <TextInput
                  label={'Name'}
                  name="emergency_contact.name"
                  value={form.values.emergency_contact.name}
                  InputProps={{
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                  onChange={(e) => {
                    const { value } = e.target as { value: string };
                    form.setFieldValue(`emergency_contact.name`, value);
                  }}
                  placeholder="Enter name…"
                />
              </Grid>
              <Grid item lg={3} md={6} xs={12}>
                <InputLabel id="contactNumber" style={{ marginBottom: '-15px' }}>
                  Phone Number
                </InputLabel>
                <SingleFieldContactInput
                  country={
                    form.values.emergency_contact.country_code?.toLowerCase() ||
                    getAccountDetails?.attributes.country_code.toLowerCase()
                  }
                  inputValue={form.values.emergency_contact.phone_number || ''}
                  onChange={(value, data) => {
                    form.setFieldValue(`emergency_contact.country_code`, data.countryCode);
                    form.setFieldValue(`emergency_contact.phone_number`, value);
                  }}
                />
              </Grid>
              <Grid item lg={3} md={6} xs={12}>
                <TextInput
                  label={'Email Address'}
                  placeholder="Enter email address…"
                  name="emergency_contact.email"
                  value={form.values.emergency_contact.email}
                  InputProps={{
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                  onChange={(e) => {
                    const { value } = e.target as { value: string };
                    form.setFieldValue(`emergency_contact.email`, value);
                    return form.handleChange(e);
                  }}
                  onBlur={(e) => {
                    return form.handleBlur(e);
                  }}
                  errorMessage={getErrorMessage(
                    getIn(form.touched, `emergency_contact.email`),
                    getIn(form.errors, `emergency_contact.email`),
                  )}
                  // errorMessage={getErrorMessage(
                  //   form.touched.email,
                  //   form.errors.email
                  //     ? form.errors.email
                  //     : !isValidEmail && !isEmailValidationLoading
                  //     ? 'Invalid Email'
                  //     : '',
                  // )}
                  // InputProps={{
                  //   tabIndex: 1,
                  //   endAdornment: (
                  //     <>
                  //       {emailValue && (
                  //         <>
                  //           {isEmailValidationLoading ? (
                  //             <LoadingSpinnerIconTwoTone style={{ fontSize: 40 }} />
                  //           ) : (
                  //             <>
                  //               {isValidEmail ? (
                  //                 <CheckboxCheckIconTwoTone style={{ fontSize: 12 }} />
                  //               ) : (
                  //                 <CloseIcon style={{ fontSize: 12 }} htmlColor={COLORS.DANGER} />
                  //               )}
                  //             </>
                  //           )}
                  //         </>
                  //       )}n
                  //     </>
                  //   ),
                  // }}
                />
              </Grid>
              <Grid item lg={3} md={6} xs={12}>
                <InputLabel id="contactNumber">Relationship</InputLabel>
                <Select
                  variant="outlined"
                  data={emergencyContactType}
                  // IconComponent={SelectArrowDownIcon}
                  fullWidth
                  placeHolder="Select"
                  className={classes.select}
                  value={form.values.emergency_contact.relationship}
                  onChange={(e) => {
                    const { value } = e.target as { value: string };
                    form.setFieldValue(`emergency_contact.relationship`, value);
                    return form.handleChange(e);
                  }}
                />
              </Grid>
            </Column>
          )}
        </Grid>
        <Grid item>
          <Heading>Personal Addresses</Heading>
          <OneColumnGrid item lg={12} md={12} xs={12} $gutter={25}>
            <Grid item lg={6} md={12} xs={12}>
              <InputLabel id="primaryLocation">Primary</InputLabel>
              {accountDetails?.data.attributes.addresses &&
              accountDetails?.data.attributes.addresses.data.filter(
                (v) => v.attributes.primary === true && v.attributes.type === 'personal',
              )?.length > 0 ? (
                accountDetails?.data.attributes.addresses.data
                  .filter((v) => v.attributes.primary === true && v.attributes.type === 'personal')
                  .map((i) => (
                    <LocationContainer>
                      <p style={{ fontSize: 14 }}>
                        {i.attributes.city_suburb} / {getCountry(i.attributes.country_code)}{' '}
                        {i.attributes.zip_code ? ' / ' + i.attributes.zip_code : ''}
                      </p>
                      <LocationActions>
                        <CustomIconButton>
                          <EditIconTwoTone
                            onClick={() => {
                              setSelectedLocation(i);
                              handleOpenLocationModal(true);
                            }}
                          />
                        </CustomIconButton>
                      </LocationActions>
                    </LocationContainer>
                  ))
              ) : (
                <LocationContainer $isEmpty={true}>
                  <p style={{ fontSize: 14 }}>No Location Added</p>
                  <LocationActions></LocationActions>
                </LocationContainer>
              )}
            </Grid>
          </OneColumnGrid>
          <Grid item lg={12} md={12} xs={12} style={{ marginTop: 20 }}>
            <InputLabel id="primaryLocation">Other Cities</InputLabel>
            <TwoColumnGrid item>
              {accountDetails?.data.attributes.addresses.data
                .filter((v) => v.attributes.type === 'personal' && !v.attributes.primary)
                .map((i) => (
                  <Grid item lg={12} md={12} xs={12}>
                    {/* <InputLabel id="primaryLocation">
                      {capitalizeFirstLetter(
                        i.attributes.address_type === 'physical_address'
                          ? 'Physical'
                          : i.attributes.address_type === 'other_address'
                          ? 'Other'
                          : i.attributes.address_type === 'postal'
                          ? 'Postal'
                          : '',
                      )}
                    </InputLabel> */}
                    <LocationContainer>
                      <p style={{ fontSize: 14 }}>
                        {i.attributes.city_suburb} / {i.attributes.state_code} / {getCountry(i.attributes.country_code)}
                        / {i.attributes.zip_code}
                      </p>
                      <LocationActions>
                        <CustomIconButton>
                          <EditIconTwoTone
                            onClick={() => {
                              setSelectedLocation(i);
                              handleOpenLocationModal(true);
                            }}
                          />
                        </CustomIconButton>
                        <CustomIconButton>
                          <TrashErrorIconTwoTone onClick={() => handleLocationDelete(i.id)} />
                        </CustomIconButton>
                      </LocationActions>
                    </LocationContainer>
                  </Grid>
                ))}
              <Grid item lg={12} md={12} xs={12}>
                <AddNewLocationButton
                  fullWidth
                  startIcon={<PlusIconTwoTone />}
                  onClick={() => {
                    setSelectedLocation(null);
                    handleOpenLocationModal(true);
                  }}
                >
                  Add New Location
                </AddNewLocationButton>
              </Grid>
            </TwoColumnGrid>
          </Grid>
        </Grid>
        <Grid item>
          <Heading>Notes</Heading>
          <Column>
            <Grid item lg={12} md={12} xs={12}>
              <TextInput
                label={'Your Notes'}
                name="notes"
                value={form.values.notes}
                onChange={form.handleChange}
                onBlur={form.handleBlur}
                placeholder="Enter notes…"
                textArea={true}
                textAreaMinRows={5}
              />
            </Grid>
          </Column>
          <FlexContainer item>
            <SaveButton
              color="primary"
              variant="contained"
              disableElevation
              onClick={() => form.handleSubmit()}
              disabled={!form.dirty}
              // disabled={true}
            >
              Save Changes
            </SaveButton>
            <NotificationText show={showSuccess} setShow={handleShowSuccess} />
          </FlexContainer>
        </Grid>
      </MainCont>
      <LocationModal
        open={openLocationModal}
        onClose={handleOpenLocationModal}
        data={selectedLocation}
        type="personal"
        ifNoAddresses={
          accountDetails &&
          accountDetails?.data.attributes.addresses.data.filter(
            (v) => v.attributes.primary === true && v.attributes.type === 'personal',
          )?.length > 0
        }
      />
    </>
  );
};

export default ContactInformation;
